var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-page-header.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<div class=\"o-row\">\n    <div class=\"g-loyalty-form__body-copy\">\n\n        <p class=\"u-global-p\">\n            ";
output += runtime.suppressValue((lineno = 6, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_sign-up-message-1"])), env.opts.autoescape);
output += " <span class=\"u-global-strong\">";
output += runtime.suppressValue((lineno = 6, colno = 77, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_sign-up-message-3"])), env.opts.autoescape);
output += "</span>\n        </p>\n\n        <p class=\"u-global-p\">\n            ";
output += runtime.suppressValue((lineno = 10, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_sign-up-message-2"])), env.opts.autoescape);
output += "\n        </p>\n\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-page-header.j2"] , dependencies)